export default __webpack_public_path__ + "static/satsummit-stlouis-2026--arch-sat-motif-7da9ed189b4e680f3fabeb33b281b739.png";